var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 10.9689H9.80208M1.44058 6.41136C1.19186 6.66064 1.05215 6.99839 1.05208 7.35053V9.21895H2.93217C3.2845 9.21895 3.62225 9.07895 3.87133 8.82928L9.413 3.2847C9.66164 3.03538 9.80126 2.69764 9.80126 2.34553C9.80126 1.99342 9.66164 1.65568 9.413 1.40636L8.86583 0.85803C8.74244 0.734568 8.59591 0.63664 8.43464 0.569844C8.27337 0.503049 8.10052 0.468696 7.92596 0.46875C7.75141 0.468804 7.57857 0.503264 7.41734 0.57016C7.25612 0.637055 7.10965 0.735075 6.98633 0.858613L1.44058 6.41136Z",
    stroke: "#262F5F",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3d007bdc654bcfa70994fabcd24ff66.svg";
export { ForwardRef as ReactComponent };